import { getMomentTz } from "@dexteel/mesf-core";
import {
	ArrowBackRounded,
	ArrowForwardRounded,
	SkipNext,
} from "@mui/icons-material";
import { Box, IconButton, TextField, Tooltip } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import type { LineShiftInfo } from "../hooks/useLineShiftNavigator";

const moment = getMomentTz();

export const LineShiftNavigator = ({
	shiftInfo,
	loading,
	onNavigate,
}: {
	shiftInfo: LineShiftInfo | null;
	loading: boolean;
	onNavigate: (date: Date | null, shiftId: number) => Promise<void>;
}) => (
	<Box display="flex" flexWrap="wrap" alignItems="center" gap={1} px={1}>
		<Tooltip title="Previous Shift">
			<span>
				<IconButton
					aria-label="Previous Shift"
					color="primary"
					size="small"
					disabled={loading || !shiftInfo?.PreviousShiftId}
					onClick={() => void onNavigate(null, shiftInfo!.PreviousShiftId!)}
				>
					<ArrowBackRounded />
				</IconButton>
			</span>
		</Tooltip>
		<DatePicker
			label="Current Date"
			timezone="UTC"
			format="MM/DD/YYYY"
			value={shiftInfo ? moment.utc(shiftInfo.CurrentProductionDate) : null}
			maxDate={
				shiftInfo?.LastProductionDate
					? moment.utc(shiftInfo.LastProductionDate)
					: moment.utc()
			}
			disabled={loading}
			onChange={(date) => {
				if (date?.isValid()) void onNavigate(date.toDate(), 0);
			}}
			slotProps={{ textField: { size: "small", sx: { width: 150 } } }}
		/>
		<TextField
			label="Shift - Crew"
			size="small"
			sx={{ width: 100 }}
			value={`${shiftInfo?.CurrentShift || ""} - ${shiftInfo?.CurrentCrew || ""}`}
			inputProps={{ readOnly: true }}
		/>
		<Tooltip title="Next Shift">
			<span>
				<IconButton
					aria-label="Next Shift"
					color="primary"
					size="small"
					disabled={loading || !shiftInfo?.NextShiftId}
					onClick={() => void onNavigate(null, shiftInfo!.NextShiftId!)}
				>
					<ArrowForwardRounded />
				</IconButton>
			</span>
		</Tooltip>
		<Tooltip title="Last Shift">
			<span>
				<IconButton
					aria-label="Last Shift"
					color="primary"
					size="small"
					disabled={
						loading ||
						!shiftInfo?.LastShiftId ||
						shiftInfo.LastShiftId === shiftInfo.CurrentShiftId
					}
					onClick={() => void onNavigate(null, shiftInfo!.LastShiftId!)}
				>
					<SkipNext />
				</IconButton>
			</span>
		</Tooltip>
	</Box>
);
